<div class="row dashboard-columns d-none d-lg-flex safe-area-bottom">
    <div class="col todays-assignments">
        <!-- todays assignments -->
        <pace-notification-card-list
            [cards]="today()"
            [count]="today().length"
            [title]="'DASHBOARD_ASSIGNMENTS_FOR_TODAY_TITLE' | translate"
            [emptyText]="noResultsLabel"
            (cardSelect)="onCardSelect($event)"
        ></pace-notification-card-list>
    </div>
    <div class="col upcoming-assignments">
        <!-- upcoming assignments -->
        <pace-notification-card-list
            [cards]="upcoming()"
            [count]="upcoming().length"
            [title]="'DASHBOARD_UPCOMING_ASSIGNMENTS_TITLE' | translate"
            [emptyText]="noResultsLabel"
            (cardSelect)="onCardSelect($event)"
        ></pace-notification-card-list>
    </div>
    <div class="col new-assignments">
        <!-- new assignments -->
        <pace-notification-card-list
            [cards]="newAssignments()"
            [count]="newAssignments().length"
            [title]="'DASHBOARD_NEW_ASSIGNMENTS_TITLE' | translate"
            [emptyText]="noResultsLabel"
            (cardSelect)="onCardSelect($event)"
        ></pace-notification-card-list>
    </div>
</div>

<tabset
    #tabSet
    paceCoreTabsRole
    class="d-block d-lg-none dashboard-tab-container-sm mh-100 overflow-y-auto overflow-x-hidden pb-5 pt-2 px-2"
>
    <tab
        [heading]="
            'DASHBOARD_ASSIGNMENTS_FOR_TODAY_TITLE_SMARTPHONE'
                | translate
                    : {
                          noOfNotifications: today().length,
                      }
        "
    >
        <pace-notification-card-list
            [cards]="today()"
            [count]="today().length"
            [emptyText]="noResultsLabel"
            (cardSelect)="onCardSelect($event)"
        ></pace-notification-card-list>
    </tab>
    <tab
        [heading]="
            'DASHBOARD_UPCOMING_ASSIGNMENTS_TITLE_SMARTPHONE'
                | translate
                    : {
                          noOfNotifications: upcoming().length,
                      }
        "
    >
        <pace-notification-card-list
            [cards]="upcoming()"
            [count]="upcoming().length"
            [emptyText]="noResultsLabel"
            (cardSelect)="onCardSelect($event)"
        ></pace-notification-card-list>
    </tab>
    <tab
        [heading]="
            'DASHBOARD_NEW_ASSIGNMENTS_TITLE_SMARTPHONE'
                | translate
                    : {
                          noOfNotifications: newAssignments().length,
                      }
        "
        [customClass]="newAssignments().length ? 'new-tab' : 'new-empty-tab'"
    >
        <pace-notification-card-list
            [cards]="newAssignments()"
            [count]="newAssignments().length"
            [emptyText]="noResultsLabel"
            (cardSelect)="onCardSelect($event)"
        ></pace-notification-card-list>
    </tab>
</tabset>
